export default __webpack_public_path__ + "static/media/022-sunscreen.3fa164eb.svg";